import React from "react";
import ToggleIcon from "../../../../common/ToggleIcon";

export default class InputMethodInstallationType extends ToggleIcon {
    render() {
        return (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M40.5 40.4999V21.6562C40.4966 21.4486 40.4518 21.2438 40.3681 21.0538C40.2843 20.8638 40.1634 20.6925 40.0125 20.5499L25.0125 6.91866C24.736 6.66569 24.3748 6.52539 24 6.52539C23.6252 6.52539 23.264 6.66569 22.9875 6.91866L7.9875 20.5499C7.83656 20.6925 7.71567 20.8638 7.63194 21.0538C7.54822 21.2438 7.50336 21.4486 7.5 21.6562V40.4999"
                    stroke={this.getColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 40.5H45" stroke={this.getColor()} strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path
                    d="M28.5 40.5V30C28.5 29.6022 28.342 29.2206 28.0607 28.9393C27.7794 28.658 27.3978 28.5 27 28.5H21C20.6022 28.5 20.2206 28.658 19.9393 28.9393C19.658 29.2206 19.5 29.6022 19.5 30V40.5"
                    stroke={this.getColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        )
    }
}